import PDFPage from '@/components/ReportPDF/PDFPage'
import PDFParagraph from '@/components/ReportPDF/PDFParagraph'
import { Text, View } from '@react-pdf/renderer'
import moment from 'moment'

const Chapter1Page = ({ reportData, setPage }) => {
  const {
    trainingPeopleTotal,
    trainingCompletionRate,
    completionRate,
    attendPeople,
    attendRate,
    firstPartyAbbreviation,
    secondPartyAbbreviation,
    secondPartyFullName,
    courseName,
    courseStartDate,
    courseEndDate,
  } = reportData || {}

  return (
    <PDFPage reportData={reportData}>
      <View>
        <Text
          render={({ pageNumber }) => {
            setPage({ chap1: pageNumber })
          }}
        />
        <Text>
          {`第一章 本文件資訊之揭露與限制\n`}
          此文件包含
          <Text>{firstPartyAbbreviation}</Text>
          執行教育安全訓練服務所取得的相關資訊。
          <Text>{secondPartyAbbreviation}</Text>
          建議採取特別
          {
            '保密措施以保護此份文件和其內容，且此問見的所有副本均將交付予客戶。資訊安全評估是根據過去的經驗、目前可取得的資訊和已知的威脅，而這些因素可造成評估過程的不確定性。\n'
          }
          由於資訊安全是一個不斷發展和變化的領域，經
          <Text>{secondPartyAbbreviation}</Text>
          {` 提供資訊安全教育訓練後，並不意味
不會發生社交工程攻擊資安事件，企業應不斷加強資安教育訓練，強化人員資安意識。\n`}
          此文件是由
          <Text>{secondPartyAbbreviation}</Text>
          製作，其內容為版權所有，並僅提供
          <Text>{firstPartyAbbreviation}</Text>
          使用，此份文件對任何 第三方的揭露須遵守
          <Text>{firstPartyAbbreviation}</Text>和<Text>{secondPartyFullName}</Text>
          之間的合約及保密協定。
        </Text>

        <PDFParagraph marginBottom={80} />

        <Text
          render={({ pageNumber }) => {
            setPage({ chap2: pageNumber })
          }}
        />
        <Text>
          {`第二章 執行摘要\n`}
          本文件提出對
          <Text>{firstPartyAbbreviation}</Text>
          的未通過社交工程演練測試的受測對象進行資訊安全教育訓練的結果，
          {`此文件統計目的是了解該企業落實強化資安意識的辦理情形及數據統計。\n`}
          此次資安教育訓練時程為
          <Text>
            {moment(courseStartDate).format('YYYY年MM月DD日')}至
            {moment(courseEndDate).format('YYYY年MM月DD日')}
          </Text>
          {`。\n`}
          第三章的受訓成果報告說明
          <Text>{firstPartyAbbreviation}</Text>
          受訓人員參與情形以及課程完成率。
        </Text>

        <PDFParagraph marginBottom={80} />

        <Text
          render={({ pageNumber }) => {
            setPage({ chap3: pageNumber })
          }}
        />
        <Text>
          {`第三章 受訓成果報告\n`}
          {`1. 訓練名稱 : ${courseName}\n`}
          2. 訓練目標和目的 : 資安教育訓練的目標在於強化受測人員的資安意識，目的在於保護受測人員
          {`所在的企業免遭受到資安攻擊造成企業損失。\n`}
          {`3. 訓練日期和時間 : ${moment(courseStartDate).format('YYYY年MM月DD日')}至${moment(
            courseEndDate,
          ).format('YYYY年MM月DD日')}\n`}
          {`4. 訓練人數 : 測試結束後不合格的人數${trainingPeopleTotal || 0}人\n`}
          {`5. 訓練名單 : 請參考附件一 \n`}
          {`6. 出席人數 : 觀看影片長度超過20%的人數 -${attendPeople || 0}人\n`}
          {`7. 出席率 : 觀看影片長度超過20%人數/總人數 -${attendRate || 0}%\n`}
          {`8. 訓練完成率 : 完成觀看影片人數/總人數 -${trainingCompletionRate || 0}%\n`}
          {`9. 未完成訓練名單 : 請參考附件二\n`}
          {`10. 單位完成率統計 : 該單位受訓出席人數/該單位受訓總人數 -${completionRate || 0}%\n`}
        </Text>
      </View>
    </PDFPage>
  )
}

export default Chapter1Page
